export default __webpack_public_path__ + "static/media/extra_out_r2.a69280c0.svg";